import { fetchCall, HandleStatusCode } from "../common/FetchHelpers";
import { GetReqConfig, GetReqPostConfig } from "../common/authHeaders";

const searchUrl = "api/attestation/search";
const detailUrl = "api/attestation/details"
const submitUrl = "api/attestation/submit"
const saveUrl = "api/attestation/save"
const reopenUrl = "api/attestation/reopen"
const exportUrl = "api/attestation/export"

const AttestationService = {

    GetDetails: (id, isMessageId = false) => {
        const url = detailUrl + (isMessageId ? `/messageId=${id}` : `/id=${id}`);
        const reqConfig = GetReqConfig();

        return fetch(url, reqConfig)
            .then((res) => HandleStatusCode(res))
            .then(async(response) => {
                if (response.status === 400) {
                    return null;
                }

                var result = await response.json();
                result.formData = JSON.parse(result.formData);
                result.template = JSON.parse(result.template);
                return result;
            });
    },

    SaveForm: (item) => {
        const jsonData = {...item, template: "", formData: JSON.stringify(item.formData) };
        let reqPostConfig = GetReqPostConfig();
        reqPostConfig.body = JSON.stringify(jsonData);

        return fetch(saveUrl, reqPostConfig)
            .then((res) => {
                HandleStatusCode(res);
            })
    },

    SubmitForm: (item) => {
        const jsonData = {...item, template: "", formData: JSON.stringify(item.formData) };
        let reqPostConfig = GetReqPostConfig();
        reqPostConfig.body = JSON.stringify(jsonData);

        return fetch(submitUrl, reqPostConfig)
            .then((res) => {
                HandleStatusCode(res);
            })
    },

    ReopenForm: (item) => {
        const jsonData = {...item, template: "", formData: JSON.stringify(item.formData) };
        let reqPostConfig = GetReqPostConfig();
        reqPostConfig.body = JSON.stringify(jsonData);

        return fetch(reopenUrl, reqPostConfig)
            .then((res) => {
                HandleStatusCode(res);
            })
    },

    Search: (criteria) => {
        let reqPostConfig = GetReqPostConfig();
        reqPostConfig.body = JSON.stringify(criteria);

        return fetchCall(searchUrl, reqPostConfig)
    },

    Export: (id, fileName)=>{

        const url = `${exportUrl}/id=${id}`;
        const reqConfig = GetReqConfig();

        return fetch(url, reqConfig)
            .then((res) => HandleStatusCode(res))
            .then(async(response) => {
                const jsonResult = await response.json();
                //console.log(jsonResult);
                //const dataUrl = `data:${jsonResult.mimeType};base64,${jsonResult.base64Data}`;
                
                const dataUrl = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${jsonResult}`;

                const link = document.createElement('a');
                link.href = dataUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);

                link.click();
                document.body.removeChild(link);

            });
    }

};

export default AttestationService;